import { render } from "./TertiaryButton.vue?vue&type=template&id=23c73f8e&scoped=true"
import script from "./TertiaryButton.vue?vue&type=script&lang=js"
export * from "./TertiaryButton.vue?vue&type=script&lang=js"

import "./TertiaryButton.vue?vue&type=style&index=0&id=23c73f8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c73f8e"],['__file',"src/scripts/common/components/TertiaryButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23c73f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23c73f8e', __exports__)) {
    api.reload('23c73f8e', __exports__)
  }
  
  module.hot.accept("./TertiaryButton.vue?vue&type=template&id=23c73f8e&scoped=true", () => {
    api.rerender('23c73f8e', render)
  })

}


export default __exports__